import { ChannelFilters } from '@/features/broadcasters/types';
import { TableKeyEnum } from '@/hooks/useTableSettingsStore';
import { createTableFiltersState } from '@/utils/table-filters';

export const useParentChannelFilters = createTableFiltersState<ChannelFilters>({
  tableKey: TableKeyEnum.PARENT_CHANNEL,
});
